var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnlocK(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.25,
    height: 14,
    viewBox: "0 0 12.25 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-unlock-alt",
    "data-name": "Icon awesome-unlock-alt",
    d: "M10.938,7H4.156V4.181a1.969,1.969,0,1,1,3.937-.025v.437a.655.655,0,0,0,.656.656h.875a.655.655,0,0,0,.656-.656V4.156A4.156,4.156,0,1,0,1.969,4.2V7H1.313A1.313,1.313,0,0,0,0,8.312v4.375A1.313,1.313,0,0,0,1.313,14h9.625a1.313,1.313,0,0,0,1.313-1.312V8.312A1.313,1.313,0,0,0,10.938,7ZM7.219,11.156a1.094,1.094,0,0,1-2.187,0V9.844a1.094,1.094,0,0,1,2.187,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocK);
export default __webpack_public_path__ + "static/media/unlocK.520e898ed26b585cc75022049142e58e.svg";
export { ForwardRef as ReactComponent };